// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_9b9fd1', '__Poppins_Fallback_9b9fd1'","fontStyle":"normal"},"className":"__className_9b9fd1"};